<script setup>
import PrivateOutdoorSpaceIcon from '@tagvenue/icons/24/private_outdoor_space.svg';
import PrivateSpaceInVenueIcon from '@tagvenue/icons/24/private_space_within_the_venue.svg';
import SemiPrivateInSpaceIcon from '@tagvenue/icons/24/semi_private_area_within_the_space.svg';
import SemiPrivateOutdoorSpaceIcon from '@tagvenue/icons/24/semi_private_outdoor_space.svg';
import SharedSpaceIcon from '@tagvenue/icons/24/shared_space.svg';
import WholeVenueIcon from '@tagvenue/icons/24/the_whole_venue.svg';
import { computed, markRaw, ref } from 'vue';

const config = ref({
  the_whole_venue: markRaw(WholeVenueIcon),
  private_space_within_the_venue: markRaw(PrivateSpaceInVenueIcon),
  semi_private_area_within_the_space: markRaw(SemiPrivateInSpaceIcon),
  shared_space: markRaw(SharedSpaceIcon),
  private_outdoor_space: markRaw(PrivateOutdoorSpaceIcon),
  semi_private_outdoor_space: markRaw(SemiPrivateOutdoorSpaceIcon),
});

const props = defineProps({
  value: { type: String, required: true },
});
const iconComponent = computed(() => config.value[props.value]);
</script>

<template>
  <component :is="iconComponent" />
</template>
